import React from 'react';
import { Link } from 'react-router-dom';

function Menu() {
  return (
    <>
      <div className="side_menu4_overlay"></div>
      <div className="side_menu4_overlay2"></div>

      <div className="side_menu_style4">
        <div className="content">

          <div className="main_links">
            <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>

              {/* HOME */}
              <li>
                <Link
                  to="/home1"
                  className="main_link"
                  style={{
                    fontSize: "32px",   // 🔥 reduced size
                    fontWeight: "500",
                    letterSpacing: "1px",
                    margin: "16px 0",
                    display: "block",
                    color: "#000",
                    textDecoration: "none",
                  }}
                >
                  Home
                </Link>
              </li>

              {/* PROJECTS */}
              <li>
                <Link
                  to="/innerpages/portfolio"
                  className="main_link"
                  style={{
                    fontSize: "32px",
                    fontWeight: "500",
                    letterSpacing: "1px",
                    margin: "16px 0",
                    display: "block",
                    color: "#000",
                    textDecoration: "none",
                  }}
                >
                  Projects
                </Link>
              </li>

              {/* ABOUT */}
              <li>
                <Link
                  to="/innerpages/about"
                  className="main_link"
                  style={{
                    fontSize: "32px",
                    fontWeight: "500",
                    letterSpacing: "1px",
                    margin: "16px 0",
                    display: "block",
                    color: "#000",
                    textDecoration: "none",
                  }}
                >
                  About
                </Link>
              </li>

              {/* TESTIMONIALS */}
              {/* <li>
                <a
                  href="#"
                  className="main_link"
                  style={{
                    fontSize: "32px",
                    fontWeight: "500",
                    letterSpacing: "1px",
                    margin: "16px 0",
                    display: "block",
                    color: "#000",
                    textDecoration: "none",
                  }}
                >
                  Testimonials
                </a>
              </li> */}

              {/* CONTACT */}
              <li>
                <Link
                  to="/innerpages/contact"
                  className="main_link"
                  style={{
                    fontSize: "32px",
                    fontWeight: "500",
                    letterSpacing: "1px",
                    margin: "16px 0",
                    display: "block",
                    color: "#000",
                    textDecoration: "none",
                  }}
                >
                  Contact
                </Link>
              </li>

            </ul>
          </div>

        </div>

        {/* SHAPES */}
        <img
          src="/home1/assets/img/chat_pat2.png"
          alt=""
          className="side_shape"
        />
        <img
          src="/home1/assets/img/chat_pat2.png"
          alt=""
          className="side_shape2"
        />

        {/* CLOSE BUTTON */}
        <span className="clss">
          <i className="la la-times"></i>
        </span>
      </div>
    </>
  );
}

export default Menu;